import React from "react";
import OutOfStock from "./outOfStock";

const Addtocart = ({
  handleAddToCart,
  currentVariant,
  loading = false,
  product,
  selectedGifts = []
}) => {
  const isPreOrder =
    currentVariant?.availableForSale &&
    product.preorderButton?.turn_pre_order_on &&
    currentVariant.inventoryPolicy === "CONTINUE";

  return (
    <div className="min-w-max sm:max-w-[532px] w-full sm:w-auto">
      {isPreOrder && (
        <div className="text-center">
          <div
            dangerouslySetInnerHTML={{
              __html: product.preorderButton.product_pre_order_message,
            }}
          ></div>
        </div>
      )}
      {!currentVariant?.availableForSale ? (
        <OutOfStock variantId={currentVariant?.shopifyId} />
      ) : (
        <div className="flex gap-5 flex-wrap items-center w-full">
          <button
            className="primary_btn pp-no-hide w-full"
            onClick={handleAddToCart}
            disabled={
              loading || (!currentVariant?.availableForSale && !isPreOrder)
            }
          >
            {currentVariant?.availableForSale && !isPreOrder && "Add to Cart"}
            {currentVariant?.availableForSale && isPreOrder && "Pre-order"}
            {!currentVariant?.availableForSale && "Sold Out"}
          </button>
        </div>
      )}

      {isPreOrder && (
        <div className="text-left mt-3">
          <span className="font-bold">Expected Delivery:</span>{" "}
          {product.preorderButton.expected_delivery}
        </div>
      )}
    </div>
  );
};

export default Addtocart;
